// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonPresentationProps } from "@insite/mobius/Button";
import { quickOrderStyles } from "@sc/App/Widgets/Basic/QuickOrder";
import { css } from "styled-components";

quickOrderStyles.container = {
    gap: 12,
};
quickOrderStyles.titleText = {
    variant: "h4",
    forwardAs: "p",
    css: css`
        margin: 0;
    `,
};
quickOrderStyles.productSelector = {};

quickOrderStyles.titleGridItem = {
    width: 12,
};

quickOrderStyles.linksGridItem = {
    css: css`
        &&& {
            flex-basis: unset;
            max-width: unset;
        }
        flex-wrap: wrap;
        gap: 8px;
        align-items: end;
        /* justify-content: end; */
        gap: 8px;
    `,
};

quickOrderStyles.selectorItem = {
    css: css`
        &&& {
            flex-grow: 1;
            flex-basis: unset;
            max-width: unset;
        }
        flex-wrap: wrap;
    `,
};

const btnStyles: ButtonPresentationProps = {
    variant: "secondary",
    typographyProps: {
        size: 12,
        lineHeight: "17px",
        weight: "bold",
    },
};

quickOrderStyles.orderUploadButton = {
    ...btnStyles,
};

quickOrderStyles.orderMultipleItemsButton = {
    ...btnStyles,
};
